import LocalizedStrings from 'react-localization';
import en from './en';
import ja from './ja';
import zh from './zh';
import ko from './ko';

const strings = new LocalizedStrings({ en, ja, zh, ko });

export default strings;
